export const SAVE = 'Save';
export const EXCEL_EXPORT = 'Excel Export';
export const EDIT_COMPANY = 'Edit Company';
